export const validationConfig = {
  sectionSelector: '.popup__section',
  inputSelector: '.popup__text',
  submitButtonSelector: '.popup__button',
  inactiveButtonClass: 'popup__button_inactive',
  inputErrorClass: '.popup__input-error',
  errorClass: '.popup__button_inactive',
  popupTextTypeError: 'popup__text-type-error',
  formInputError: 'popup__input-error_active'
};

